import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import { BreadcrumbsItemProps, BreadcrumbsProps } from './types';

const BreadcrumbsBase = forwardRef<HTMLDivElement, BreadcrumbsProps>(
  ({ className, children, ...props }, ref) => {
    const classes = twMerge('breadcrumbs text-sm', className);

    return (
      <div ref={ref} className={classes} {...props}>
        <ul>{children}</ul>
      </div>
    );
  },
);

const Item = forwardRef<HTMLLIElement, BreadcrumbsItemProps>(
  ({ href, icon, children, ...props }, ref) => {
    const content = icon ? (
      <span className="inline-flex items-center gap-2">
        {icon}
        {children}
      </span>
    ) : (
      children
    );

    return (
      <li ref={ref} {...props}>
        {href ? <Link to={href}>{content}</Link> : content}
      </li>
    );
  },
);

BreadcrumbsBase.displayName = 'Breadcrumbs';
Item.displayName = 'Breadcrumbs.Item';

export const Breadcrumbs = Object.assign(BreadcrumbsBase, {
  Item,
});
